module.exports = __webpack_public_path__ + "img/card-andarbhar.9a2eb16.jpg";